export default {
  getNoticeList: '/v2/notification/message/pagingMsg'
}
